import React, { useState } from "react";
import { Pencil } from "lucide-react";
import { finApi } from "@/lib/financeApi";
import { btnGold, useLoad } from "@/components/nds/windows/finance/parts";
import { PaycheckEdit } from "@/components/nds/windows/finance/PaycheckEdit";
import { useIsSuper } from "@/components/nds/windows/finance/InvoiceActions";

/** Edit a paycheck's split (rent, case mgmt, savings, line of credit, tithe, cash) right where it's shown. */
export function PaycheckInline({ pid, onDone, startOpen = false }) {
  const sa = useIsSuper();
  const [open, setOpen] = useState(startOpen);
  const [s, load] = useLoad(() => finApi.get(`/paychecks/${pid}`), [pid]);
  const pc = s.data;
  if (!sa || !pc || pc.status === "voided" || pc.archived) return null;
  if (!open) return <button type="button" onClick={() => setOpen(true)} data-testid={`flow-paycheck-edit-open-${pid}`} className={`${btnGold} inline-flex items-center gap-1`}><Pencil className="h-3 w-3" /> Edit paycheck</button>;
  return (
    <div data-testid={`flow-paycheck-inline-${pid}`}>
      <PaycheckEdit pc={{ ...pc, split: { tithe: 0, rent: 0, case_management: 0, savings: 0, checking: 0, ...pc.split } }} correct={pc.status === "verified"} anywhere
        onCancel={() => setOpen(false)} onDone={() => { setOpen(false); load(); onDone?.(); }} />
    </div>
  );
}
